import { Component, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { debounceTime, distinctUntilChanged, tap, flatMap, map } from 'rxjs/operators';
import { AgRendererComponent } from 'ag-grid-angular';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { AdminProtocolsStorage } from '../shared/admin-protocols-storage';
import { ProtocolGridRowItem } from './protocol-grid';
import { UserPermissionsStorage } from '../../user-permissions/user-permissions-storage';

@Component({
    selector: 'protocol-change-accessibility',
    template: require('./protocol-change-accessibility.component.html'),
    styles: [require('./protocol-change-accessibility.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProtocolChangeAccessibilityComponent implements AgRendererComponent, OnDestroy {
    public isAccessibleFC = new FormControl();
    public readonly disableActivation$: Observable<boolean>;

    private subscription: Subscription;

    constructor(private protocolsStorage: AdminProtocolsStorage, private changeDetectorRef: ChangeDetectorRef, private readonly permissionsStorage: UserPermissionsStorage) {
        this.disableActivation$ = permissionsStorage.userPermissions.pipe(
            map(permissions => permissions.has('ProtocolReadAccess')),
        );
    }

    public agInit(row: ProtocolGridRowItem): void {
        if (!row.data) {
            return;
        }

        this.isAccessibleFC.setValue(row.data.isAccessible);

        this.subscription = this.isAccessibleFC.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged(),
                tap(() => {
                    this.isAccessibleFC.disable({ onlySelf: true, emitEvent: false });
                    row.data.isAccessible = !row.data.isAccessible;
                    this.changeDetectorRef.markForCheck();
                }),
                flatMap((newValue: boolean) => {
                    return this.protocolsStorage.updateAccessibility(row.data.id, newValue);
                }),
                tap(() => {
                    this.isAccessibleFC.enable();
                    this.changeDetectorRef.markForCheck();
                })
            )
            .subscribe();

        this.disableActivation$.subscribe(data => {
            if (data) {
                this.isAccessibleFC.disable({ onlySelf: true, emitEvent: false });
            }
        });
    }

    public refresh() {
        return false;
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}